<template>
  <div id="con">
    <img src="@/assets/wechat.png" alt="微信二维码" />
    <!-- <img @click="gotoalbb()" src="@/assets/albb.png" alt="阿里巴巴连接" /> -->
    <p>©2020 大连世有电力科技有限公司 版权所有</p>
    <p>辽ICP备11008925号-3</p>
    <br /><br /><br />
  </div>
</template>

<style scoped>
#con {
  background-color: #ffffff;
  text-align: center;
}
#con > img {
  width: 200px;
}
#con > p {
  font-size: 14px;
  color: #303133;
  margin: 0;
}
</style>

<script>
export default {
  methods: {
    gotoalbb() {
      window.open("https://shiyoukeji.1688.com/");
    }
  }
};
</script>
